// Central design tokens for the 2026 refresh. Source values from here so the inline-style
// pages stay visually consistent. Kept framework-free on purpose (no CSS lib dependency).

export const colors = {
  // Brand — indigo→violet gradient accent
  primary: '#4f46e5',
  primaryHover: '#4338ca',
  primarySoft: '#eef2ff',
  gradient: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
  gradientSoft: 'linear-gradient(135deg, #eef2ff 0%, #faf5ff 100%)',

  // Semantic
  success: '#16a34a',
  successSoft: '#f0fdf4',
  danger: '#e11d48',
  dangerSoft: '#fff1f2',
  warning: '#d97706',
  warningSoft: '#fffbeb',
  info: '#0284c7',
  infoSoft: '#f0f9ff',

  // Neutrals (slate)
  bg: '#f6f7fb',
  surface: '#ffffff',
  surfaceMuted: '#f8fafc',
  border: '#e8ebf2',
  borderStrong: '#d8dce6',
  text: '#0f172a',
  textMuted: '#64748b',
  textDim: '#94a3b8',

  // Sidebar (deep indigo-slate)
  sidebar: '#13131f',
  sidebarActive: '#4f46e5',
};

export const radii = { sm: 8, md: 12, lg: 16, xl: 20, pill: 999 };

export const shadows = {
  xs: '0 1px 2px rgba(15,23,42,0.04)',
  sm: '0 1px 3px rgba(15,23,42,0.06), 0 1px 2px rgba(15,23,42,0.04)',
  md: '0 4px 16px rgba(15,23,42,0.06), 0 2px 4px rgba(15,23,42,0.04)',
  lg: '0 12px 32px rgba(15,23,42,0.10)',
  xl: '0 24px 60px rgba(15,23,42,0.18)',
  focus: '0 0 0 3px rgba(99,102,241,0.25)',
};

export const spacing = { xs: 4, sm: 8, md: 12, lg: 16, xl: 24, xxl: 32 };

export const typography = {
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  h1: { fontSize: 24, fontWeight: 800, letterSpacing: '-0.02em' },
  h2: { fontSize: 18, fontWeight: 700, letterSpacing: '-0.01em' },
  body: { fontSize: 14, fontWeight: 400 },
  small: { fontSize: 12, fontWeight: 500 },
};

const theme = { colors, radii, shadows, spacing, typography };
export default theme;
